
$(document).ready(function() {

  
const variantLow = "54275247374721";
const variantHigh = "54275247407489";


const conversion_rate = window.Shopify.currency.rate;

const static_price = 100*conversion_rate;


function addToCart(variantId, quantity) {
    const miniCart = document.querySelector('mini-cart');
    if (!miniCart) {
        console.error('MiniCart element not found');
        return;
    }
    const data = {
        id: variantId,
        quantity: quantity,
        sections: miniCart.getSectionsToRender().map(section => section.id), 
        sections_url: window.location.pathname
    };
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function(response) {
            if (response.status) {
                console.error('Error adding to cart:', response.description);
                return;
            }
            console.log('Product added to cart:', response);
            miniCart.renderContents(response);
            $(document).trigger('cart:updated');
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-add-to-cart', productVariantId: variantId });
        },
        error: function(error) {
            console.error('Error adding to cart:', error);
        }
    });
}

function deleteCart(variantId, quantity, callback) {
    const miniCart = document.querySelector('mini-cart');
    if (!miniCart) {
        console.error('MiniCart element not found');
        return;
    }
    const data = {
        id: variantId,
        quantity: quantity,
        sections: miniCart.getSectionsToRender().map(section => section.id), 
        sections_url: window.location.pathname
    };
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: data,
        dataType: 'json',
        success: function(response) {
            if (response.status) {
                console.error('Error deleting from cart:', response.description);
                return;
            }
            console.log('Product removed from cart:', response);
            miniCart.renderContents(response);
            $(document).trigger('cart:updated');
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-delete-cart', productVariantId: variantId });
            if (callback) callback();
        },
        error: function(error) {
            console.error('Error deleting from cart:', error);
        }
    });
}


$('.product-form__submit').click(function(){
   setTimeout(function(){
  
  fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            var items = data.items;
            var matchingItem = items.find(dta => dta.id == variantLow);
            var matchingHighItem = items.find(dta => dta.id == variantHigh);
            var total_price = Number(data.items_subtotal_price) / 100;
            if (matchingItem) {
            var matching_price = Number((matchingItem.price / 100) * matchingItem.quantity);
            } else {
            console.log("No matching paid variant (variantLow) found in cart.");
            var matching_price = 0; // or handle accordingly
            }
            if (total_price >= 100+matching_price && matchingItem) {
                console.log('Switching to free product');
                deleteCart(Number(variantLow), 0, function() {
                    addToCart(Number(variantHigh), 1);
                });
            } else if (total_price < 100 && matchingHighItem) {
                console.log('Switching to paid product');
                deleteCart(Number(variantHigh), 0, function() {
                    addToCart(Number(variantLow), 1);
                });
            }
           if(total_price >= 100){
            
        $(".second-varints-money").hide();
        }else{
              $(".second-varints-money").show();
        }
        })
        .catch(err => {
            console.log('Something went wrong:', err);
        });  
  },1100)  

 setTimeout(function(){
  
  fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            var items = data.items;
            var matchingItem = items.find(dta => dta.id == variantLow);
            var matchingHighItem = items.find(dta => dta.id == variantHigh);
            var total_price = Number(data.items_subtotal_price) / 100;
            if (matchingItem) {
            var matching_price = Number((matchingItem.price / 100) * matchingItem.quantity);
            } else {
            console.log("No matching paid variant (variantLow) found in cart.");
            var matching_price = 0; // or handle accordingly
            }
            if (total_price >= 100+matching_price && matchingItem) {
                console.log('Switching to free product');
                deleteCart(Number(variantLow), 0, function() {
                    addToCart(Number(variantHigh), 1);
                });
            } else if (total_price < 100 && matchingHighItem) {
                console.log('Switching to paid product');
                deleteCart(Number(variantHigh), 0, function() {
                    addToCart(Number(variantLow), 1);
                });
            }
           if(total_price >= 100){
            
        $(".second-varints-money").hide();
        }else{
              $(".second-varints-money").show();
        }
        })
        .catch(err => {
            console.log('Something went wrong:', err);
        });  
  },1300)  

  
})

$('body').on('click', 'input.add-product.add-product-jtpl', function(e) {
    e.preventDefault();


    fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            var total_price = Number(data.items_subtotal_price) / 100;
           

            if (total_price >= 100) {
                addToCart(Number(variantHigh), 1);
            } else {
                addToCart(Number(variantLow), 1);
            }
        })
        .catch(err => {
            console.log('get new error', err);
        });
});
document.addEventListener('cart:updated', function(evt) {
    setTimeout(function(){
  
  fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            var items = data.items;
            var matchingItem = items.find(dta => dta.id == variantLow);
            var matchingHighItem = items.find(dta => dta.id == variantHigh);
            if (matchingItem) {
            var matching_price = Number((matchingItem.price / 100) * matchingItem.quantity);
            } else {
            console.log("No matching paid variant (variantLow) found in cart.");
            var matching_price = 0; 
            }
          console.log('matching_price:',matching_price)
            var total_price = Number(data.items_subtotal_price) / 100;
               console.log('Total Price You Get:',total_price)
            if (total_price >= 100+matching_price && matchingItem) {
                console.log('Switching to free product');
                deleteCart(Number(variantLow), 0, function() {
                    addToCart(Number(variantHigh), 1);
                });
            } else if (total_price < 100 && matchingHighItem) {
                console.log('Switching to paid product');
                deleteCart(Number(variantHigh), 0, function() {
                    addToCart(Number(variantLow), 1);
                });
            }
          if(total_price >= 100){
            
        $(".second-varints-money").hide();
        }else{
              $(".second-varints-money").show();
        }
        })
        .catch(err => {
            console.log('Something went wrong:', err);
        });  
  },900) 


 setTimeout(function(){
  
  fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            var items = data.items;
            var matchingItem = items.find(dta => dta.id == variantLow);
            var matchingHighItem = items.find(dta => dta.id == variantHigh);
            if (matchingItem) {
            var matching_price = Number((matchingItem.price / 100) * matchingItem.quantity);
            } else {
            console.log("No matching paid variant (variantLow) found in cart.");
            var matching_price = 0; 
            }
          console.log('matching_price:',matching_price)
            var total_price = Number(data.items_subtotal_price) / 100;
               console.log('Total Price You Get:',total_price)
            if (total_price >= 100+matching_price && matchingItem) {
                console.log('Switching to free product');
                deleteCart(Number(variantLow), 0, function() {
                    addToCart(Number(variantHigh), 1);
                });
            } else if (total_price < 100 && matchingHighItem) {
                console.log('Switching to paid product');
                deleteCart(Number(variantHigh), 0, function() {
                    addToCart(Number(variantLow), 1);
                });
            }
          if(total_price >= 100){
            
        $(".second-varints-money").hide();
        }else{
              $(".second-varints-money").show();
        }
        })
        .catch(err => {
            console.log('Something went wrong:', err);
        });  
  },300) 


  
  
});



const intervalId = setInterval(function () {
  
    const $element = $(`.cstm-${variantHigh}`);
    if ($element.length > 0) {
        $element.find('.quantity').css('pointer-events', 'none');
        clearInterval(intervalId);
    }
}, 10);
  

  

function updateCart(){
    setTimeout(function (){
    var url = window.location.href;
    // console.log(url.indexOf("/cart"));
    if(url.indexOf("/cart") > -1){
      location.reload(true);
      return false;
      
     
     }else{
      //$("div.loader-cart-drwer-jtpl").addClass("loading");
      //$("div.loader-cart-drwer-jtpl.loading").show();
       $.ajax({
          url: '/pages/contact-us?section_id=mini-cart',
          async: false,
          type: 'GET',
          dataType: 'html',
          success:function(carthtml) {
            $("form div.mini-cart__inner").hide();
            // console.log(carthtml);
            $('#main-cart-items').html($(carthtml).find('#main-cart-items').html());
            $('.mini-cart__footer').html($(carthtml).find('.mini-cart__footer').html());
            $("form div.mini-cart__inner").show();
            // $("div.loader-cart-drwer-jtpl").removeClass("loading");
            //$("div.loader-cart-drwer-jtpl").hide();
          }
        });
      }
      
                 
  
    }, 500);
  
  return false;
}
  
$('body').on('click', '.nothnks-jtpl', function(){  
 $(".cart-notification-cstm").hide();
});

$(".size_modal").hide();
$("#size_chart").click(function(){
$(".size_modal").css("display","flex");
$('body').addClass("cstm-variant-active");
});
$(".cstm-close").click(function(){
$(".size_modal").hide();
$('body').removeClass("cstm-variant-active");
});
  
  	$('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('active');
		$('.tab-content').removeClass('active');

		$(this).addClass('active');
		$("#"+tab_id).addClass('active');
	});


 // product size guide start


  /***** variant specification popup ***/

  if(window.innerWidth > 749){
$(".cstm_size_modal").hide();
  }  
$("#cstmsize_chart").click(function(){
  
$('body').addClass("cstm-variant-active");
  if(window.innerWidth > 749){
    $(".cstm_size_modal").css("display","flex");
  }else{
    $(".cstm_size_modal").addClass("slideModal");
  }

  $('.custom-variant-sizes:first').trigger('click');
  $('.cstm_content video').trigger('play');
   $('button.custom-variant-sizes').each(function () {
  var getText =   $(this).text().replace(' ','');
    console.log(getText);
    var getSplit = getText.split('/')[1];
    console.log(getSplit)
    //$(this).text(getSplit);
});
});
$(".cstm-variant-close").click(function(){
$(".cstm_size_modal").hide();
$('body').removeClass("cstm-variant-active");
  $(".cstm_size_modal").removeClass("slideModal");
});
  
//   $('body').on('click', '.cstm_variant_select .custom-variant-sizes', function(e) {
//     //code
//     e.preventDefault();
    
//     var variant = $(this).attr("data-id");
//     //console.log(variant);
//     $(".cstm_content").attr("style","display:none !important");
//     $(".cstm_content.variant-"+variant).attr("style","display:block !important");
    
// });
  // video poup video and content start
  $('.custom-variant-sizes:first').trigger('click');
$('body').on('click', '.cstm_variant_select .custom-variant-sizes', function(e) {
  e.preventDefault();

  var getData = $(this).parents('.cstm_variant_select').attr('data-index');
  
  // Hide all variant content and titles
  $('.cstm_content.variant').hide();
  $('.cstm_varianttitle').hide();

  // Check if the data-index exists
  if ($('.cstm_content.variant[data-index="'+getData+'"]').length > 0) {
    // If it exists, show the corresponding variant
    $('.cstm_content.variant[data-index="'+getData+'"]').show();
    $('.cstm_varianttitle[data-index="'+getData+'"]').show();
  } else {
    // If it doesn't exist, show the "not available" content
    $('.not_avilable_content').show();
  }
});

 // video poup video and content end
$(".custom-variant-sizes").click(function(){
$(".custom-variant-sizes").removeClass("variant-active");
$(this).addClass("variant-active");
});
   var getColour = $('input[name="Color"]:checked').val();
if(getColour == undefined || getColour == ' '){
    
var getSize = $('input[name="Size"]:checked').val();
$('.custom_product_varaint_options option').each(function () {
   var getEachVal = $(this).text();
    if(getSize == getEachVal){
        var gteId = $(this).val();
        console.log(gteId);
      $('.custom_metafields_varaiant_text').removeClass('is-active');
        $('.custom_metafields_varaiant_text[value="'+gteId+'"]').addClass('is-active');
        
    }else{

$('.custom_metafields_varaiant_text').hide();
    }
});
}else{
    var getColour = $('input[name="Color"]:checked').val();
var getSize = $('input[name="Size"]:checked').val();
var combination = getColour +' / '+ getSize;
console.log('kjkj--'+combination);
$('.custom_product_varaint_options option').each(function () {
   var getEachVal = $(this).text();
     console.log('thidss'+getEachVal);
    if(combination == getEachVal){
        var gteId = $(this).val();
        console.log(gteId);
 $('.custom_metafields_varaiant_text').removeClass('is-active')
        $('.custom_metafields_varaiant_text[value="'+gteId+'"]').addClass('is-active');
        
    }else{

$('.custom_metafields_varaiant_text').hide();
    }
});
}
  $('body').on('click','.custom_product_info_wrapper',function (e) {
e.preventDefault();
    //alert();
   
    $(this).toggleClass('active-icon-accodion');
  $(this).find('.slide_toggle_wrapper').toggleClass("is-accordion-active");
});
//size chart js start
  
var $tabs = $('.fit-size-chart__tab');
var $charts = $('.fit-size-chart__charts');

$charts.first().addClass('size-chart-selected');
$tabs.first().addClass('active-button');

$tabs.click(function(){
    $charts.removeClass('size-chart-selected');
    $tabs.removeClass('active-button');
    $(this).addClass('active-button');
    
    var getAttr = $(this).attr('data-tab');
  
    $('.cstmsize-' + getAttr).addClass('size-chart-selected');
});


//size chart js end

  // fit guide js start
  $('.newvideo:visible .content-video:first').show();
function resetSlider(){
   var desktop_index =  $('.fit-guide-button').attr('index-attr');
  var mb_index = $('.fit-guide-dropdown:visible .selected').attr('data-index');
var newindex = null;
if(desktop_index){
  newindex = desktop_index
}else{
  newindex = mb_index
}
  

  
  return new Promise(function(resolve, reject) {
    $('.data-slider').each(function() {
      var $slider = $(this);
      if ($slider.data('flickity')) {
        $slider.flickity('destroy');
      }
  // var flkty = $slider.flickity({
  //   touch: true,
  //   imagesLoaded: true,
  //   contain: false,
  //   initialIndex: newindex,
  //   dots: false,
  //   draggable: false,
  //   adaptiveHeight: true,
  //   prevNextButtons: true,
  //   groupCells: false,
  //   wrapAround: true,
  //   fade: false,
  //   cellAlign: 'center',
  // }).data('flickity'); 

 
 
  flkty.on('change', function(index) {
   
        $('.topdata-container:visible').flickity('select', index); 
    $('.fit-guide-button').attr('index-attr',index);

    });
    });

    $('.topdata-container').each(function() {
      var $slider = $(this);
      if ($slider.data('flickity')) {
        $slider.flickity('destroy');
      }
      // $slider.flickity({
      //   imagesLoaded: true,
      //   touch: true,
      //   contain: true,
      //   initialIndex: newindex,
      //   dots: false,
      //   draggable: false,
      //   adaptiveHeight: true,
      //   prevNextButtons: false,
      //   groupCells: false,
      //   wrapAround: false,
      //   fade: true,
      //   cellAlign: 'center',
      // });
    });

    resolve();
  });
}




var $tabs1 = $('.sizeguidechart__tab');
var $charts1 = $('.fit-guide-container');

$charts1.first().addClass('fit-guide-selected');
$tabs1.first().addClass('fit-guide-button');


$tabs1.click(function(){
var video_index = $(this).index();
$('.newvideo').hide();
  $('.fit-guide-variant .cstm_variant_select button').removeClass('variant-active');
  $charts1.removeClass('fit-guide-selected');
  $tabs1.removeClass('fit-guide-button');
  $(this).addClass('fit-guide-button');
$('.newvideoshow'+'-'+video_index).show();
  
  var getAttr = $(this).attr('data-tab');
  var getnewvideindx = $(this).attr('index-attr');
  $('.fitguide-' + getAttr).addClass('fit-guide-selected');
  
$('.fit-guide-dropdown:visible .init').text($('.data-slider1:visible .selected').text());
 $('.newvideo:visible .contentpopup-'+getnewvideindx).show();
  resetSlider().then(function() {
var mb_index = $('.fit-guide-dropdown:visible .selected').attr('data-index');

   
  });
  $('.fit-guide-selected').find('.topdata-inner-container').each(function(){
    if($(this).index() == getnewvideindx){
        $(this).addClass('selected');

    } else {
        $(this).removeClass('selected');
    }
});
  $('.fit-guide-selected').find('.showdata').each(function(){
    
     if($(this).index() == getnewvideindx){
        $(this).addClass('selected');
        $('.init:visible').text($(this).text())
    } else {
        $(this).removeClass('selected');
    }
  })
});

$(document).on('click','.data-slider1:visible li',function(){
   var image_index = $(this).index();
   $('.newvideo:visible .content-video').hide();
   $('.topdata-container:visible').flickity('select', image_index); 
   $('.fit-guide-button').attr('index-attr',image_index);
   $('.newvideo:visible .contentpopup-'+image_index).show
   $('.fit-guide-selected').find('.topdata-inner-container').each(function(){
        if($(this).index() == image_index){  
            $(this).addClass('selected');
        } else {
            $(this).removeClass('selected');
        }
    });
})





$('.fit-guide-dropdown:visible .init').text($('.data-slider1:visible .selected').text());

$(document).on('click', '.data-slider1:visible li', function(){
    $('.data-slider1:visible li').removeClass('selected');
    $(this).addClass('selected');
    setTimeout(function(){
        $('.fit-guide-dropdown:visible .init').text($('.data-slider1:visible .selected').text());
    }, 50);
    $('.data-slider1:visible li').hide(); 
});

$(document).on('click', '.fit-guide-dropdown:visible .init', function(event) {
    event.stopPropagation();
    $('.showdata').toggle();  
});

$('body').on('click', function(event) {
      $('.showdata').hide();
});
$('.fitguide-center-side-container .custom-variant-sizes').removeClass('variant-active');
$(document).on('click','.cross-popup-video',function () {
    $('.cstm_content-popup').hide();
  $('.custom-variant-sizes').removeClass('variant-active');
   $('body').removeClass('cstm-variant-active');
    
})
  $(document).on('click','.fit-guide-variant .cstm_variant_select',function () {
//$('body').addClass('cstm-variant-active');
    
})

  
  //fit guide js end
setInterval(function(){
   $('.custom_product_info_wrapper').removeClass('is-active');
},100)

// add class and remove popup js start
$('.custom-variant-sizes').click(function() {
  var getIndex = $('.fit-guide-button').attr('index-attr');
    $('.video-popup-size').css('display', 'flex');
    $('.contentpopup-'+getIndex).css('display', 'block');
     $('body').addClass('video-popup-size-cstm');
});

$('.cross-popup-video,.cstm-variant-close').click(function() {
    $('.video-popup-size, .content-video').css('display', 'none');
     $('body').removeClass('video-popup-size-cstm');
});
  
// add class and remove popup js End
var onloadattr = $('.cstmlook-section').val();

$('.custom_metafields_varaiant_text-' + onloadattr).show();
if (window.location.href.includes("/products")) {
  var checkInterval = setInterval(function () {
    var $swatchItems = $(".swatch-view-item");

    if ($swatchItems.length > 0) {
      $swatchItems.each(function () {
        var pro_variant_id = $(this).attr("option-value-id");

        if (pro_variant_id === "9343319769473") {
          console.log("hey id found..");
          $(this).hide();
        }
      });

      clearInterval(checkInterval); 
    }
  }, 100);
}

$(document).on('click','.swatch-view-item',function () {
  $('.custom_metafields_varaiant_text').hide();
    setTimeout(function(){
     
var newurl = $('.cstmlook-section').val();
$('.custom_metafields_varaiant_text-' + newurl).show();
    },400)
})
  
});

 function updateCart() {
    $.getJSON('/cart.js', function (updatedCart) {
      const cartRefreshEvent = new CustomEvent('cart:refresh', { detail: updatedCart });
      document.dispatchEvent(cartRefreshEvent);
    });
  }